import React from "react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { vscDarkPlus } from "react-syntax-highlighter/dist/esm/styles/prism";

const CodeBlock = ({ value }) => {
  if (!value?.code) {
    return null;
  }

  return (
    <div className='container mx-auto flex justify-center'>
      <div className='my-8 w-[95%]'>
        <SyntaxHighlighter
          language={value.language || "javascript"}
          style={vscDarkPlus}
          className='rounded-lg'
        >
          {value.code}
        </SyntaxHighlighter>
        {value.caption && (
          <p className='text-center font-rubik text-md text-gray-500 mt-2'>
            {value.caption}
          </p>
        )}
      </div>
    </div>
  );
};

export default CodeBlock;
